import React, {ReactNode} from "react";
import '../../styles/components/settings/settings-menu-item.scss';

interface ISettingsMenuItemProps {
  children: ReactNode;
}

export default function SettingsMenuItem({children}: ISettingsMenuItemProps) {
  return (
    <div className="settings-menu-item">
      {children}
    </div>
  );
}
